// Se o plano do cliente logado exige plano de comunicação aprovado para fazer pedidos.
//
// A flag vem junto das respostas de status/quantidade de pedidos (`exigePlanoComunicacao`),
// que são as telas por onde o cliente passa. Fica em cache porque o menu, o guard de rota e o
// websocket precisam da resposta de forma síncrona, sem ter um endpoint próprio para consultar.
//
// Enquanto não se sabe, vale `true`: é como todo plano se comportava antes do self-service,
// então um cliente de plano regular nunca perde o plano de comunicação por causa do cache frio.
const STORAGE_KEY = "mention.exigePlanoComunicacao";

export const setExigePlanoComunicacao = (valor) => {
  if (valor === undefined || valor === null) return;
  localStorage.setItem(STORAGE_KEY, valor ? "1" : "0");
};

export const exigePlanoComunicacao = () => localStorage.getItem(STORAGE_KEY) !== "0";
